import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { useSelector, useDispatch } from "react-redux";

interface OnboardingDataState {
  preOnBoardingData: any[];
  postOnboardingData: any[];
  postOnBoardingLastUpdated: any;
}

const initialState: OnboardingDataState = {
  preOnBoardingData: [],
  postOnboardingData: [],
  postOnBoardingLastUpdated: null,
};

const onBoardingDataSlice = createSlice({
  name: "onboardingData",
  initialState,
  reducers: {
    savePreOnboardingData: (state, action: PayloadAction<any[]>) => {
      state.preOnBoardingData = action.payload;
    },
    clearPreOnboardingData: (state) => {
      state.preOnBoardingData = [];
    },
    savePostOnboardingData: (state, action: PayloadAction<any[]>) => {
      state.postOnboardingData = action.payload;
    },
    clearPostOnboardingData: (state) => {
      state.postOnboardingData = [];
    },
    postOnBoardingTimeStamp: (state, action: PayloadAction<any[]>) => {
      state.postOnBoardingLastUpdated = action.payload;
    },
    clearPostOnboardingTimeStamp: (state) => {
      state.postOnBoardingLastUpdated = null;
    },
  },
});

export const {
  savePreOnboardingData,
  clearPreOnboardingData,
  savePostOnboardingData,
  clearPostOnboardingData,
  postOnBoardingTimeStamp,
  clearPostOnboardingTimeStamp,
} = onBoardingDataSlice.actions;

export const useOnboardingDataSlice = () => {
  const dispatch = useDispatch();
  const onboardingData = useSelector((state: any) => state.onboardingData);

  return {
    ...onboardingData,
    savePreOnboardingData: (data: any[]) =>
      dispatch(savePreOnboardingData(data)),
    clearPreOnboardingData: () => dispatch(clearPreOnboardingData()),
    savePostOnboardingData: (data: any[]) =>
      dispatch(savePostOnboardingData(data)),
    clearPostOnboardingData: () => dispatch(clearPostOnboardingData()),
    setPostOnBoardingTimeStamp: (data: any[]) =>
      dispatch(postOnBoardingTimeStamp(data)),
    preOnBoardingData: onboardingData?.preOnBoardingData,
    postOnboardingData: onboardingData?.postOnboardingData,
    postOnBoardingLastUpdated: onboardingData?.postOnBoardingLastUpdated,
    clearPostOnboardingTimeStamp: () =>
      dispatch(clearPostOnboardingTimeStamp()),
  };
};

export default onBoardingDataSlice.reducer;
